import { Component } from '@angular/core';

@Component({
  selector: 'app-reminder-sets',
  templateUrl: './reminder-sets.component.html',
  styleUrl: './reminder-sets.component.scss'
})
export class ReminderSetsComponent {
  showAddReminderSetModal = false;
  reminderSetToEdit: any = null;

  addReminderSet() {
    this.reminderSetToEdit = { title: '', description: '' };
    this.showAddReminderSetModal = true;
  }
  closeAddReminderSetModal() {
    this.showAddReminderSetModal = false;
    this.reminderSetToEdit = null;
  }
  reminderSets: any[] = [];
  selectedReminderSetId: string = '';
  selectedReminderSet: any = null;

  saveNewReminderSet() {
    if (this.reminderSetToEdit) {
      const newId = 'rs-' + Date.now();
      const newSet = { ...this.reminderSetToEdit, id: newId };
      this.reminderSets.push(newSet);
      this.selectedReminderSetId = newId;
      this.selectedReminderSet = newSet;
    }
    this.closeAddReminderSetModal();
  }
}
